var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_ico/tel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.1332 18 0.1332 18 6.1332 0 6.1332"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1_ico/tel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.858,15.8614 C8.495,15.8614 7.39,14.7204 7.39,13.3144 C7.39,11.9064 8.495,10.7664 9.858,10.7664 C11.221,10.7664 12.327,11.9064 12.327,13.3144 C12.327,14.7204 11.221,15.8614 9.858,15.8614 L9.858,15.8614 Z M12.639,8.6754 L12.639,5.8664 L11.178,5.8664 L11.178,7.0554 L8.539,7.0554 L8.539,5.8664 L7.077,5.8664 L7.077,8.6754 L5.34,8.6754 L3.358,13.1534 L3.358,14.0384 L3.358,14.6744 L3.358,16.5594 L3.358,16.8094 L3.358,17.1734 C3.358,17.5564 3.632,17.8664 3.969,17.8664 L15.747,17.8664 C16.085,17.8664 16.358,17.5564 16.358,17.1734 L16.358,16.8094 L16.358,16.5594 L16.358,14.6744 L16.358,14.0384 L16.358,13.1534 L14.351,8.6754 L12.639,8.6754 Z",
    id: "Fill-1",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1.000000, 2.866800)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2582134,1.07923282 C13.9044257,0.483394553 10.9251154,0.1332 9.00048873,0.1332 C7.13548737,0.1332 4.09557426,0.483394553 2.74178659,1.07923282 C1.37138203,1.68217648 0,3.03220186 0,4.62279567 C0,5.49574441 0.418354602,6.01342331 0.519033397,6.1332 L1.24528917,6.1332 L2.09959272,6.1332 L3.43285365,6.1332 C3.60684225,6.1332 3.98609829,5.35160636 3.98609829,5.03287857 C3.98609829,4.47053717 3.69970133,3.68995859 3.69970133,3.68995859 C3.71631822,3.30322199 3.86391529,3.02103624 4.46994298,2.75001611 C5.56959001,2.25974373 7.98685854,2.23741249 9.00048873,2.23741249 C10.0131415,2.23741249 12.43041,2.25974373 13.5290796,2.75001611 C14.1360847,3.02103624 14.2836818,3.30322199 14.3002987,3.68995859 C14.3002987,3.68995859 14.0139017,4.47053717 14.0139017,5.03287857 C14.0139017,5.35160636 14.3931578,6.1332 14.5661689,6.1332 L15.9004073,6.1332 L16.7547108,6.1332 L17.4809666,6.1332 C17.5806679,6.01342331 18,5.49574441 18,4.62279567 C18,3.03220186 16.6276405,1.68217648 15.2582134,1.07923282",
    id: "Fill-3",
    fill: "#616161",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.bdf1e4b4b03bd1f49941e812e739116b.svg";
export { ForwardRef as ReactComponent };